import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import CarrierFields from "./CarrierFields";
import { Alert } from "@mui/material";
import { useState } from "react";
import { carriersStyle } from "./carriersStyle";
import { useCreateCarrierMutation, useGetAllCarriersQuery, useUpdateCarrierMutation } from "./carrierSlice";
import NotificationProvider from "components/NotificationProvider";
import Validator from "services/validator";

const EditCarrierDialog = ({ open, carrier, setCarrier, onClose, carrierId }) => {
    const classes = carriersStyle();

    let { data: carrierFromApi, error: carrierError, isLoading: isLoadingCarrier } = useGetAllCarriersQuery(carrierId, { skip: !carrierId || !!carrier });

    const carrierData = carrier ?? carrierFromApi?.[0] ?? [];

    const [errors, setErrors] = useState();
    const [valid, setValid] = useState(true);
    const [updateCarrier, { isLoading: isUpdating }] = useUpdateCarrierMutation();
    const [addCarrier, { isLoading: isAdding }] = useCreateCarrierMutation();

    const isSaving = isUpdating || isAdding;

    const onChange = (key, val) => {
        setCarrier({ ...carrierData, [key]: val });

        setErrors({ ...errors, [key]: val ? undefined : errors[key] });
    }

    const onChangePocField = (key, val, pocIndex) => {
        const pocArray = carrierData?.pocInfo?.length
            ? [...carrierData?.pocInfo] : [];

        pocArray[pocIndex] = { ...pocArray[pocIndex], [key]: val, 'isPrimary': pocIndex === 0 };

        setCarrier({ ...carrierData, pocInfo: pocArray?.length ? pocArray : [{ [key]: val, 'isPrimary': pocIndex === 0 }] });
    }

    const displayError = (field, severity = 'error') => {
        return !!errors?.[field] && <Grid className={classes.alertWrapper}>
            <Alert severity={severity} >
                {errors?.[field]}
            </Alert>
        </Grid>
    }

    const onSave = async () => {
        if (!validate()) {
            return;
        }

        let result;
        if (carrierData?.id) {
            result = await updateCarrier(carrierData);
        } else {
            result = await addCarrier(carrierData);
        }

        if (result && !result.error) {
            NotificationProvider.success("Carrier saved successfully");
            onClose()
        } else {
            NotificationProvider.error("Failed to save Carrier");
        }
    }

    const validate = () => {
        const msgs = {};
        let valid = true;

        const pocInfo = carrierData?.pocInfo;

        if (!carrierData?.name) { valid = false; msgs['carrierName'] = 'Carrier name is required' };

        pocInfo?.map((poc, index) => {
            if ((poc?.email != null && poc?.email != "") && !Validator.validateEmail(poc?.email)) { valid = false; msgs[`pocEmail${index}`] = "Email invalid" };
            if (poc?.phone != null && !Validator.validatePhone(poc?.phone)) { valid = false; msgs[`pocPhone${index}`] = "Phone invalid" };

            if (poc?.address) {
                if (!poc?.city) { valid = false; msgs[`city${index}`] = 'City is required' };
                if (!poc?.state) { valid = false; msgs[`state${index}`] = 'State is required' };
                if (!poc?.zipCode) { valid = false; msgs[`zipcode${index}`] = 'Zipcode is required' };
            }
        })

        setErrors(msgs);
        valid ? setValid(true) : setValid(false);

        return valid;
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth='md'>
            <DialogTitle>{`${carrierData?.id ? "Edit " : "Add "} Carrier`}</DialogTitle>
            <DialogContent>
                <CarrierFields
                    carrier={carrierData}
                    onChange={onChange}
                    onChangePocField={onChangePocField}
                    displayError={displayError}
                    isNew={true}
                />
            </DialogContent>
            <DialogActions>
                <Grid container justifyContent="space-between" direction='row-reverse'>
                    <Grid item={4}>
                        <Button
                            onClick={onClose}
                            color="primary"
                            variant='outlined'
                            disabled={isSaving}
                            className={classes.button}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={onSave}
                            color="primary"
                            variant="contained"
                            disabled={isSaving}
                        >
                            {isSaving ? 'Saving...' : 'Save'}
                        </Button>
                    </Grid>
                    {!valid ? <Grid item xs={8}>
                        <Alert severity={'error'}>
                            Please correct all errors
                        </Alert>
                    </Grid> : <></>}
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default EditCarrierDialog;